// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/js/" + chunkId + "." + {"106":"186f16dd","126":"b62c2fde","315":"ee933ffb","383":"76332fce"}[chunkId] + ".chunk.js";
};